<template>
  <tr>
    <td>{{ displayIndex }}</td>
    <td>{{ contentTypeText }}</td>
    <td class="left">
      <dl class="td_split_row">
        <dt class="tit">{{ itemData.boardTitle }}</dt>
        <dd class="cont">{{ keywordText }}</dd>
      </dl>
    </td>
    <td>
      <AudioButton :fileUrl="itemData.fileUrl" />
      <p class="time">{{ playTime }}</p>
    </td>
    <td>{{ $utils.dateText(itemData.createDate) }}</td>
    <td>{{ $utils.dateText(itemData.updateDate) }}</td>
    <td>{{ itemData.playCount }}</td>
    <td>
      <button type="button" class="lamp" :class="boardTypeClass" @click="onClickBoardType">{{ boardText }}</button>
    </td>
    <td>
      <button type="button" class="lamp" :class="useTypeClass" @click="onClickUseType">{{ useText }}</button>
    </td>
    <td>
      <button type="button" class="btn_function blue" @click="onClickRegister">수정</button>
      <button type="button" class="btn_function" @click="onClickDelete">삭제</button>
    </td>
  </tr>
</template>

<script>
import AudioButton from './Item.audioButton';

export default {
  props: {
    itemData: Object,
  },
  components: {AudioButton},
  computed: {
    displayIndex() {
      return this.itemData.id;
    },
    keywordText() {
      return _.isEmpty(this.itemData.keywordList) ? '-' : this.itemData.keywordList.join(', ');
    },
    playTime() {
      let hour = parseInt(this.itemData.soundInfo / 3600);
      let min = parseInt((this.itemData.soundInfo % 3600) / 60);
      let sec = this.itemData.soundInfo % 60;

      hour = hour < 10 ? `0${hour}` : hour;
      min = min < 10 ? `0${min}` : min;
      sec = sec < 10 ? `0${sec}` : sec;

      if (hour == '00') {
        return `${min} : ${sec}`;
      } else {
        `${hour} : ${min} : ${sec}`;
      }

      return `${hour} : ${min} : ${sec}`;
    },
    boardTypeClass() {
      return this.itemData.fileType === 'RECOMMEND' ? 'blue' : 'gray';
    },
    boardText() {
      return this.itemData.fileType === 'RECOMMEND' ? '추천' : '일반';
    },

    useTypeClass() {
      return this.itemData.useYn ? 'blue' : 'gray';
    },
    useText() {
      return this.itemData.useYn ? '사용중' : '미사용';
    },
    contentTypeText() {
      switch (this.itemData.contentType) {
        case 'HEALTHTOKTOK':
          return '건강톡톡';
        case 'GOODTHINKING':
          return '좋은생각';
        case 'MINDGYM':
          return '마음체조';
        default:
          return '-';
      }
    },
  },
  methods: {
    onClickBoardType() {
      const type = this.itemData.fileType === 'NORMAL' ? '추천' : '일반';
      confirm(`${this.displayIndex}번 콘텐츠를 '${type}'으로 변경하시겠습니까?`).then(() => {
        this.$axios.put(`/admin/happy/health/${this.itemData.id}/recommend`).then(() => this.$emit('stateChange'));
      });
    },
    onClickUseType() {
      const type = this.itemData.useYn ? '미사용' : '사용중';
      confirm(`${this.displayIndex}번 콘텐츠를 '${type}'으로 변경하시겠습니까?`).then(() => {
        this.$axios.put(`/admin/happy/health/${this.itemData.id}/use`).then(() => this.$emit('stateChange'));
      });
    },
    onClickRegister() {
      this.$emit('clickRegister');
    },
    onClickDelete() {
      confirm(`${this.displayIndex}번 콘텐츠를 삭제하시겠습니까?`).then(() => {
        this.$axios.delete(`/admin/happy/health/${this.itemData.id}`).then(() => {
          alert('삭제되었습니다.');
          this.$emit('stateChange');
        });
      });
    },
  },
};
</script>
